import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import DataSelectionMenu from './pages/DataSelectionMenu';

import { useIsAuthenticated } from '@azure/msal-react';
import React from "react";
import PlayGroundPage from "./pages/PlaygroundPage";
import MasterDataPage from "./pages/MasterDataPage";

const AnimatedRoutes: React.FC<{ isAuthenticated: boolean }> = ({ isAuthenticated }) => {
  const location = useLocation();
  const state = location.state;
  const transition =
    state != null && typeof state === 'object' && 'transition' in state
      ? (state as { transition?: string }).transition
      : undefined;

  let transitionClassName = 'route-transition';
  if (transition === 'data-to-master') {
    transitionClassName = 'route-transition route-transition-data-to-master';
  }
  if (transition === 'master-to-data') {
    transitionClassName = 'route-transition route-transition-master-to-data';
  }

  return (
    // key forces a remount on each navigation so the CSS animation replays on every route change
    <div key={location.pathname} className={transitionClassName}>
      <Routes location={location}>
        <Route path="/" element={isAuthenticated ? <DataSelectionMenu /> : <Login />} />
        <Route path="/task-list" element={<Navigate to="/data-selection" replace />} />
        <Route path="/navigation" element={isAuthenticated ? <PlayGroundPage /> : <Login />} />
        <Route path="/master-data" element={isAuthenticated ? <MasterDataPage /> : <Login />} />
        <Route path="/data-selection" element={isAuthenticated ? <DataSelectionMenu /> : <Login />} />
      </Routes>
    </div>
  );
};

const AppRouter: React.FC = () => {
    const isAuthenticated = useIsAuthenticated();

  return (
    <Router>
      <AnimatedRoutes isAuthenticated={isAuthenticated} />
    </Router>
  );
};

export default AppRouter;
